import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, Grid, Stack, Typography } from '@mui/material';
import Iconify from '../../../components/Iconify';

const LandingCard = ({ landing, onDisable, onEnable, onEdit }) => {
  const navigate = useNavigate();
  const { _id, image, content, type, title, status } = landing;

  return (
    <Card sx={{ mt: '8px' }}>
      <Grid container>
        <Grid item sm={5}>
          <img
            alt="logo"
            style={{ width: '100%', height: '380px', objectFit: 'cover' }}
            src={`${process.env.REACT_APP_IMAGE}${image}`}
          />
        </Grid>
        <Grid item sm={7} p={3}>
          <Stack direction={'column'}>
            <Typography variant="h5" color="#A7202C">
              {title}
            </Typography>
            <div className="ck-content" dangerouslySetInnerHTML={{ __html: landing && landing.content }} />
            <Typography variant="h5" color="black">
              {type}
            </Typography>
            <Stack direction="row" sx={{ mt: 1 }} justifyContent="space-between">
              <Typography variant="subtitle2">Trạng thái: </Typography>
              <Stack direction="row" spacing={2}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    background: status === 'Disable' ? '#ff9a001c' : '#1aff0012',
                    color: status === 'Disable' ? '#f39c12' : '#42f233',
                    p: '2px',
                    borderRadius: '3px',
                  }}
                >
                  <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                  <Typography fontWeight={'bold'} variant="caption">
                    {status}
                  </Typography>
                </Box>
              </Stack>
            </Stack>

            <Stack sx={{ mt: 1 }} direction="row" justifyContent="space-between">
              <Stack direction="row" spacing={1}>
                <Button variant="outlined" color="success" onClick={() => onEdit(_id)}>
                  Cập nhật
                </Button>
                {status === 'Disable' ? (
                  <Button variant="outlined" onClick={() => onEnable(_id)}>
                    Kích hoạt
                  </Button>
                ) : (
                  <Button variant="outlined" color="warning" onClick={() => onDisable(_id)}>
                    Ngừng hoạt động
                  </Button>
                )}
              </Stack>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};

export default LandingCard;
